"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AnnotationsProvider = void 0;

var _annotationsResponses = require("./response-parsers/annotations-responses");

var _types = require("../../types");

var _assert = require("../../utils/assert");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var AnnotationsProvider =
/*#__PURE__*/
function () {
  function AnnotationsProvider(dataService) {
    _classCallCheck(this, AnnotationsProvider);

    this._dataService = dataService;
  }

  _createClass(AnnotationsProvider, [{
    key: "list",
    value: function list(imageId) {
      _assert.assert.isRequired({
        imageId: imageId
      }, 'AnnotationsProvider');

      return this._dataService.request({
        methodName: 'GetAnnotations2',
        data: {
          ImageId: imageId
        },
        parseResponseDelegate: _annotationsResponses.createGetAnnotations2Response
      });
    }
  }, {
    key: "addLayers",
    value: function addLayers(imageId, layers) {
      _assert.assert.isRequired({
        imageId: imageId,
        layers: layers
      }, 'AnnotationsProvider');

      _assert.assert.isNotEmptyArray({
        layers: layers
      }, 'AnnotationsProvider');

      return this._dataService.request({
        methodName: 'PutAnnotations3',
        data: {
          ImageId: imageId,
          AnnotationsNode: {
            Tag: 1,
            Annotations: {
              Annotation: layers.map(function (l) {
                var attrs = {
                  Id: l.id,
                  Name: l.name,
                  Type: l.type,
                  Selected: _types.BooleanAsNumber.Out(l.isSelected),
                  LineColor: l.lineColor,
                  Visible: _types.BooleanAsNumber.Out(l.isVisible),
                  ReadOnly: _types.BooleanAsNumber.Out(l.isReadOnly),
                  NameReadOnly: _types.BooleanAsNumber.Out(l.isNameReadOnly),
                  LineColorReadOnly: _types.BooleanAsNumber.Out(l.isLineColorReadOnly)
                };

                if (l.isIncremental) {
                  attrs.Incremental = _types.BooleanAsNumber.Out(l.isIncremental);
                }

                if (l.inputAnnotationId) {
                  attrs.InputAnnotationId = l.inputAnnotationId;
                }

                if (l.macroName) {
                  attrs.MacroName = l.macroName;
                }

                if (l.macroId) {
                  attrs.MacroId = l.macroId;
                }

                return {
                  $: attrs
                };
              })
            }
          }
        },
        parseResponseDelegate: _annotationsResponses.createPutAnnotations3Response
      });
    }
  }, {
    key: "deleteLayers",
    value: function deleteLayers(imageId, ids) {
      _assert.assert.isRequired({
        imageId: imageId,
        ids: ids
      }, 'AnnotationsProvider');

      _assert.assert.isNotEmptyArray({
        ids: ids
      }, 'AnnotationsProvider');

      return this._dataService.request({
        methodName: 'PutAnnotations3',
        data: {
          ImageId: imageId,
          AnnotationsNode: {
            DeletedAnnotations: [// Not entirely sure why but we need to drop an array inside an array to generate the correct XML.
            ids.map(function (id) {
              return {
                Annotation: {
                  $: {
                    Id: id
                  }
                }
              };
            })]
          }
        }
      });
    }
  }]);

  return AnnotationsProvider;
}();

exports.AnnotationsProvider = AnnotationsProvider;


//////////////////
// WEBPACK FOOTER
// ./node_modules/lbs-pi-platform-access/es/data-server/annotations/AnnotationsProvider.js
// module id = 81
// module chunks = 0